var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bmui-cell_arrow2" }, [
    _c("p", { staticClass: "bmui-cell_arrow2-title" }, [
      _vm._v(_vm._s(_vm.title || "TITLE")),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNeed,
              expression: "isNeed"
            }
          ],
          staticClass: "bmui-cell_arrow2-isNeed"
        },
        [_vm._v("*")]
      )
    ]),
    _vm._v(" "),
    _c("i", { staticClass: "bmui-cell_arrow2-icon" })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7f629dc", { render: render, staticRenderFns: staticRenderFns })
  }
}